import PriceInfo from './PriceInfo'

export default PriceInfo
